import { Button } from 'native-base'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import Wrapper from '../../components/Wrapper'
import QRCode from 'react-qr-code'

function VerQR() {
  const params = useParams()
  const navigate = useNavigate()
  var base_url = window.location.origin;
  const [qr] = useState(`${base_url}/recursos/ver/${params.qr}`)
  useEffect(() => {
  }, [])
  const imprimir1 = () => {
    window.open(`${base_url}/imprimirqr/1/${params.qr}`, '_blank', 'toolbar=0,location=0,menubar=0');

  }
  const imprimir2 = () => {
    window.open(`${base_url}/imprimirqr/2/${params.qr}`, '_blank', 'toolbar=0,location=0,menubar=0');

  }
  
  const imprimir3 = () => {
    window.open(`${base_url}/imprimirqr/3/${params.qr}`, '_blank', 'toolbar=0,location=0,menubar=0');

  }
  return (
    <Wrapper title='Datos del recurso' subtitle=''>
      <div className='page-wrapper'>
        <div className='page-content'>
          <div className='col-lg-12 '>
            <div className='col'>
              <div className='card'>
                <div className='card-body'>
                  <div className="page-content flex flex-col items-center justify-center"
                    style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}
                  >
                    {/* QR centrado */}
                    <div className="flex justify-center mb-6 w-full"
                      style={{ width: '100%', display: 'flex', justifyContent: 'center' }}
                    >
                      <QRCode
                        size={300}
                        style={{ height: "auto", maxWidth: "30%", width: "30%" }}
                        value={qr as string}
                        viewBox="0 0 300 300"
                      />
                    </div>

                    {/* Leyenda */}
                    <h3 className="text-lg font-semibold mt-3 text-center text-bold">Imprimir en:</h3>

                    {/* Botones */}
                    <div className="flex gap-2"
                      style={{display: 'flex', justifyContent: 'center'}}
                    >
                      <Button
                        className="rounded-xl bg-blue-600 text-white py-2 px-4 hover:bg-blue-700 transition"
                        colorScheme={'blue'}
                        onPress={imprimir1}
                      >
                        Grande
                      </Button>
                      <Button
                        className="rounded-xl bg-green-600 text-white py-2 px-4 hover:bg-green-700 transition"
                        colorScheme={'green'}
                        onPress={imprimir2}
                      >
                        Mediano
                      </Button>
                      <Button
                        className="rounded-xl bg-purple-600 text-white py-2 px-4 hover:bg-purple-700 transition"
                        colorScheme={'purple'}
                        onPress={imprimir3}
                      >
                        Pequeño
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
					</div>
          {/* <!--end row--> */}
        </div>
      </div>
    </Wrapper>
  )
}

export default VerQR
